export function userBanner(isPro) {
  if (isPro) {
    document.body.classList.remove("free-user");
    document.body.classList.add("pro-user");
  } else {
    document.body.classList.remove("pro-user");
    document.body.classList.add("free-user");
  }
}
